export default function studentname(state = '', action) {
  if (action.type === 'studentname') {
    return state = action.name;
  } else {
    return state;
  }
}
